import { store } from "../store";
import { AlertState } from "./types";
import { actions } from "./slices";

export const setAlert = async (alert: AlertState) => {
  store.dispatch(actions.setAlert(alert));
};

export const clearAlert = async () => {
  store.dispatch(actions.clearAlert());
};

export const setIsSubscriptionModalOpen = async (isOpen: boolean) => {
  store.dispatch(actions.setIsSubscriptionModalOpen(isOpen));
};

export const setIsCreditModalOpen = async (isOpen: boolean) => {
  store.dispatch(actions.setIsCreditModalOpen(isOpen));
};
